<template>
  <div class="role_wrapper">
    <div style="margin-bottom:20px;">
      <el-button
        v-auth="'sys:user:add'"
        @click="handleEdit('',0)"
        type="primary"
        icon="el-icon-plus"
      >{{$t('user.addUser')}}</el-button>
    </div>

    <el-table
      border
      v-loading="loading"
      :row-class-name="tableRowClassName"
      :data="userListData"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column :label="$t('user.loginName')" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.userName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="公司名称" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.companyName }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('user.email')" width="180">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>{{$t('user.email')}}: {{ scope.row.email }}</p>
            <div slot="reference" class="name-wrapper">
              <el-tag size="medium">{{ scope.row.email }}</el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <!-- <el-table-column label="头像" width="180">
        <template slot-scope="scope">
          <img style="width:50px;" :src="scope.row.imageAddress" alt />
        </template>
      </el-table-column>-->
      <el-table-column :label="$t('user.phone')" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{scope.row.phone}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="state" :label="$t('common.status')" width="120" align="center">
        <template scope="scope">
          <el-button type="text" v-if="scope.row.status==2" plain>{{$t("common.stop")}}</el-button>
          <el-button type="text" v-if="scope.row.status==1" plain>{{$t("common.start")}}</el-button>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.handle')">
        <template slot-scope="scope">
          <el-button
            size="small"
            v-auth="'sys:user:edit'"
            @click="handleEdit(scope.row,1)"
          >{{$t("common.edit")}}</el-button>
          <el-button
            size="small"
            v-auth="'sys:user:resetPassword'"
            @click="handlePassword(scope.row)"
          >{{$t("user.resetPass")}}</el-button>
          <el-button
            type="info"
            size="mini"
            @click="blockUp(scope.row)"
            v-auth="'sys:user:stop'"
            v-if="scope.row.status==1 && userInfo.userName != scope.row.userName"
          >{{$t("common.stop")}}</el-button>
          <el-button
            type="success"
            size="mini"
            @click="startUsing(scope.row)"
            v-auth="'sys:user:stop'"
            v-if="scope.row.status==2 && userInfo.userName != scope.row.userName"
          >{{$t("common.start")}}</el-button>
          <el-button
            size="small"
            type="danger"
            v-auth="'sys:user:delete'"
            v-if="userInfo.userName != scope.row.userName"
            @click="handleDelete(scope.$index, scope.row)"
          >{{$t("common.delete")}}</el-button>
          <el-button
            size="small"
            type="info"
            v-auth="'sys:user:tracker'"
            v-if="($route.query.label == 'TREX' || $route.query.label == 'INR') && userInfo.userName != scope.row.userName"
            @click="handleTracker(scope.$index, scope.row)"
          >{{$t("common.trackerAuth")}}</el-button>
        </template>
      </el-table-column>
    </el-table>


    <div style="margin-top:20px;text-align:right">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10,20,50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalSize"
      ></el-pagination>
    </div>


    <el-dialog :visible.sync="showPasswordBox">
      <el-form :model="passwordForm">
        <el-form-item :label="$t('user.loginName')" prop="userName" :label-width="formLabelWidth">
          <el-input v-model="passwordForm.userName" :disabled="nameEdit" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('login.password')" prop="password" :label-width="formLabelWidth">
          <el-input v-model="passwordForm.password" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showPasswordBox = false">{{$t("common.cancle")}}</el-button>
        <el-button type="primary" @click="changePassword">{{$t("common.ok")}}</el-button>
      </div>
    </el-dialog>



    <!-- 编辑用户弹窗 -->
    <el-dialog :title="titleName" :visible.sync="showBox" v-if="showBox">
      <el-form ref="formAdd" :rules="rules" :model="form">
        <el-form-item
          v-if="roleSys"
          :label="$t('user.companyChoice')"
          :label-width="formLabelWidth"
          prop="companyId"
        >
          <el-select
            v-model="form.companyId"
            @change="handleCompany"
            :placeholder="$t('user.companyChoice')"
          >
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目选择" :label-width="formLabelWidth" prop="moduleName">
          <el-select v-model="moduleName" multiple @change="getModelId" placeholder="项目选择">
            <el-option
              v-for="item in modulesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('user.roleChoice')" :label-width="formLabelWidth" prop="roles">
          <el-select v-model="form.roles" multiple :placeholder="$t('user.roleChoice')">
            <el-option v-for="item in rolesList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('company.businessChioce')"
          :label-width="formLabelWidth"
          prop="comName"
        >
          <el-select v-model="comName" multiple :placeholder="$t('company.businessHolder')">
            <el-option
              v-for="item in companyChackList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancleSubmit">{{$t("common.cancle")}}</el-button>
        <el-button type="primary" @click="submitData('formAdd')">{{$t("common.ok")}}</el-button>
      </div>
    </el-dialog>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
import { localRead } from "@/utils/tools";
import {
  userList,
  editUserList,
  addUserList,
  delUserList,
  userStatus,
  resetPassword,
  roleBusiListAll,
  checkUserName
} from "@/api/sys/userList";
import { getModules } from "@/api/user";
import { companyListAll } from "@/api/sys/companyList";
import { roleListAll, roleListAllByCompany } from "@/api/sys/roleList";
import { MessageBox, Message } from "element-ui";
import UPDATE from '@/components/page/update.vue'
import URL from '@/views/sys/util/url'
import Qs from 'qs'
let TeamIdList = {};
export default {
    components: {
        UPDATE
    },
  data() {

    let  check = (rule, value, callback) => {
      if (this.moduleName.length === 0) {
        callback(new Error(this.$t("common.rulesText")));
      } else {
        callback();
      }
    };
    let checkBusiness = (rule, value, callback) => {
      if (this.comName.length === 0) {
        callback(new Error(this.$t("common.rulesText")));
      } else {
        callback();
      }
    };
    let checkroles = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error(this.$t("common.rulesText")));
      } else {
        callback();
      }
    };

    return {
      updateData:{
          cols:[
              { title: 'id', field: 'id',hidden:true},
              { title: "用户id", field: 'userId',hidden:true},
              { title: "用户名称", field: 'displayName'},
              { title: "团队id", field: 'teamId',type:2,optionList:TeamIdList,isNumber:true},
          ],
      },
      userInfo: JSON.parse(
        localRead(this.$route.query.label + "_sys_userInfo")
      ),
      userListData: [],
      titleName: this.$t("user.editUserName"),
      formLabelWidth: "150px",
      companyList: "", // 公司列表
      changeType: 1,
      showBox: false,
      edit: true,
      nameEdit: true,
      currentPage: 1,
      companyChackList: [],
      pageSize: 10,
      totalSize: 0,
      showPasswordBox: false,
      langcheckList: [],
      passwordForm: {
        password: ""
      },
      modulesList: [],
      moduleName: [],
      form: {
        companyId: "",
        displayName: "",
        email: "",
        id: 0,
        imageAddress: "",
        phone: "",
        remark: "",
        userName: "",
        roles: [],
        modelId: [],
        language: []
      },
      companyId: "", //请求接口的
      modelId: "", //请求接口的
      comName: [],
      rolesList: [],
      formSearch: {
        userName: "",
        status: ""
      },
      loading: true,
      roleSys: false, //公司选项是否出现
      rules: {
        displayName: [
          {
            required: true,
            message: this.$t("common.rulesText"),
            trigger: "blur"
          }
        ],
        userName: [
          {
            required: true,
            trigger: "blur",
            validator:checkName
          }
        ],
        phone: [
          {
            required: true,
            trigger: "blur",
            validator: checkPhone
          }
        ],
        companyId: [
          {
            required: true,
            message: this.$t("common.rulesText"),
            trigger: "change"
          }
        ],
        moduleName: [
          {
            required: true,
            message: this.$t("common.rulesText"),
            trigger: "change",
            type: "array",
            validator: check
          }
        ],
        comName: [
          {
            required: true,
            message: this.$t("common.rulesText"),
            trigger: "change",
            type: "array",
            validator: checkBusiness
          }
        ],
        roles: [
          {
            required: true,
            message: this.$t("common.rulesText"),
            trigger: "change",
            type: "array",
            validator: checkroles
          }
        ],
        langcheckList: [
          {
            type: "array",
            required: true,
            message: "请至少选择一种语言",
            trigger: "change",
            validator: checkLanguage
          }
        ]
      }
    };
  },
  created() {

    //判断用户是否是管理员 来决定 公司选择 是否出现
    //是就出现
    if (this.userInfo.isBy) {
      this.roleSys = true;
    } else {
      this.roleSys = false;
      //非管理员则传公司的 id去获取有哪些项目
      this.getModels(this.userInfo.companyId);
      this.getUserCheckList(this.userInfo.companyId);
    }

    if (this.$route.query.label == 'TREX' || this.$route.query.label == 'INR'){
      this.$axios.post(URL.userTeam.list).then(res => {
        for (let i in res.result) {
          TeamIdList[res.result[i].id] = res.result[i].name;
        }
      })
    }

  },
  mounted() {
    this.getUserList();
  },
  methods: {
    cancleSubmit() {
      this.showBox = false;
    },
    //选择项目后获取角色选择
    getModelId(val) {
      this.modelId = val;
      this.form.roles = [];
      this.getRoleList(val, this.companyId);
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    handleSelectionChange() {},
    //选择公司之后获取公司相关的项目
    handleCompany(val) {
      this.companyId = val;
      this.moduleName = [];
      this.comName = [];
      this.form.roles = [];
      this.getModels(val);
      this.getUserCheckList(val);
    },
    getModels(companyId) {
      getModules(companyId).then(res => {
        this.modulesList = res.result;
      });
    },
    getRoleListAll() {
      roleListAll().then(res => {
        if (res.code == 0) {
          this.rolesList = res.result;
        }
      });
    },
    getRoleList(modelId, companyId) {
      let data = {
        modelId: modelId,
        companyId: companyId
      };
      roleListAllByCompany(data).then(res => {
        if (res.code == 0) {
          this.rolesList = res.result;
        }
      });
    },
    getUserCheckList(val) {
      roleBusiListAll(val).then(res => {
        if (res.code == 0) {
          this.companyChackList = res.result;
        }
      });
    },
    getUserList() {
      let data = {
        userName: "",
        status: "",
        pageSize: this.pageSize,
        pageNum: this.currentPage
      };
      userList(data).then(res => {
        if (res.code == 0) {
          this.userListData = res.result.list;
          this.totalSize = res.result.total;
          this.loading = false;
        }
      });
    },
    blockUp(row) {
      row.status = 2;
      this.changeStatus(row);
    },
    resetSearch() {
      this.formSearch = {};
    },
    changeStatus(pram) {
      let data = {
        id: pram.id,
        status: pram.status
      };
      userStatus(data).then(res => {
        if (res.code == 0) {
          console.log("更改成功");
        }
      });
    },
    startUsing(row) {
      row.status = 1;
      this.changeStatus(row);
    },
    getCompanyList() {
      companyListAll().then(res => {
        this.companyList = res.result;
      });
    },
    addUser() {
      this.titleName = this.$t("user.addUser");
      this.showBox = true;
    },
    submitData(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.form.businessId = [];
          for (let i in this.comName) {
            this.form.businessId.push(this.comName[i]);
          }
          this.form.businessId = String(this.form.businessId);
          this.form.modelId = [];
          for (let i in this.moduleName) {
            this.form.modelId.push(this.moduleName[i]);
          }
          this.form.modelId = String(this.form.modelId);

           //语言
          this.form.language = [];
          for (let i in this.langcheckList) {
            this.form.language.push(this.langcheckList[i]);
          }
          this.form.language = String(this.form.language);
          if (this.changeType == 1) {
            editUserList(this.form).then(res => {
              if (res.code == 0) {
                Message({
                  message: this.$t("common.changeSu"),
                  type: "success"
                });
              }
              this.getUserList();
            });
          } else {
            addUserList(this.form).then(res => {
              if (res.code == 0) {
                Message({
                  message: this.$t("common.addSu"),
                  type: "success"
                });
              }
              this.getUserList();
            });
          }

          this.showBox = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onSubmitSearch() {
      userList(this.formSearch).then(res => {
        if (res.code == 0) {
          this.userListData = res.result.list;
        }
      });
    },
    editId(idData) {
      let arr = [];
      for (let i in idData) {
        arr.push(idData[i].id);
      }
      return arr;
    },
    handleEdit(row, type) {
      this.getCompanyList();
      this.changeType = type;
      let updateObject;
      updateObject = Object.assign({}, row);
      this.showBox = true;
      if (type == 1) {
        this.companyId = row.companyId
        this.getModels(this.userInfo.companyId);
        this.getUserCheckList(row.companyId);
        this.moduleName = this.editId(updateObject.modelId);
        this.getRoleList(this.moduleName, updateObject.companyId);
        this.comName = this.editId(updateObject.businessId);
          if(updateObject.language != null){
           this.langcheckList = updateObject.language.split(',');
        }else{
          this.langcheckList = []
        }
        this.form = updateObject;
        this.titleName = this.$t("common.edit");
        this.edit = true;
      } else {
        this.moduleName = [];
        this.comName = [];
        this.langcheckList = []
        this.form.roles = [];
        for (let key in this.form) {
          this.form[key] = "";
        }
        this.titleName = this.$t("common.addNew");
        this.edit = false;
      }
    },
    handleDelete(node, data) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            delUserList(data.id).then(res => {
              if (res.code == 0) {
                this.getUserList();
              }
            });

            done();
          } else {
            done();
          }
        }
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleTracker(node, data) {
        this.$axios.post(URL.userTeam.queryTeamByUserId,Qs.stringify({userId:data.id})).then(res => {
            console.log(res);
            let teamId = res.result?res.result.teamId:"";
            let id = res.result?res.result.id:null;
            this.$refs.childUpdate.open({id:id,userId:data.id,displayName:data.displayName,teamId:teamId});
        })
    },
    submit(model){
        //根据是否包含id更新还是添加
        this.dataChanage(URL.userTeam.edit,model,res => {
            if (res.code == 0){
                this.$refs.childUpdate.close();
                this.$message.success("suc");
            }else{
                this.$message.error(res.message);
            }
        })
    },
    dataChanage(url,option,suc,fail){
        this.$axios.post(url, Qs.stringify(option || {})).then(res => {
            if(suc && (typeof suc == 'function')) suc(res);
        }).catch(res => {
            if(fail && (typeof fail == 'function')) fail(res);
        })
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getUserList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getUserList();
    }

  }
};
</script>
<style lang="scss" scoped>
.role_wrapper {
  margin: 50px;
  border: 1px solid #ebebeb;
  border-radius: 3px;
  transition: 0.2s;
  padding: 20px;
}
.role_wrapper:hover {
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6),
    0 2px 4px 0 rgba(232, 237, 250, 0.5);
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
